var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionsIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 721,
    viewBox: "0 0 365 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 360.5H364.18a357.3 357.3 0 00-27.714-137.955c-18.3-43.738-45.125-83.48-78.942-116.955-33.818-33.476-73.966-60.03-118.152-78.148A367.428 367.428 0 00.001 0v360.5z",
    fill: "#F8F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 721H364.18a357.3 357.3 0 00-27.714-137.955c-18.3-43.738-45.125-83.48-78.942-116.955-33.818-33.476-73.966-60.031-118.152-78.148A367.43 367.43 0 00.001 360.5V721z",
    fill: "#F8F5FF"
  })));
}
export default SvgQuestionsIllustration;